import { AxiosResponse } from 'axios';
import v1 from '../v1';
import v3 from '../v3';

export interface IRegion {
  _id: string;
  name: string;
  path: GeoJSON.Polygon;
  geometry?: GeoJSON.Polygon;

  // //新增
  area:number;
  parkingLotsCount:string;
  roadNetLength:number;
  forbiddenAreaCount:string;
  prohibitedAreaCount:string;
}

export async function findList(): Promise<AxiosResponse<{
  items: IRegion[],
  count: number,
}>> {
  return await v3({
    url: '/operation.region',
    params: {
      selector: '_id name path geometry',
    },
  });
}


export async function findListInfo(id: string): Promise<AxiosResponse<null | IRegion>> {
  return await v1({
    method: 'get',
    url: `/operation/region/${id}/info`,
  });
}

export async function updatePath(id: string, coordinates: ILngLat[]): Promise<AxiosResponse<null | IRegion>> {
  return await v1({
    method: 'put',
    url: `/operation/region/${id}/path`,
    data: {
      path: coordinates,
      coordinateSystem: 'wgs84',
    },
  });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/operation/region.ts